import { useParams } from "react-router";

import { ClientViewContent } from "./client-view-content";

export default function ClientViewPage() {
  const { id } = useParams();
  return <ClientViewContent clientId={id!} />;
}
